import { render, staticRenderFns } from "./smsexample.vue?vue&type=template&id=b9cd6e22&"
import script from "./smsexample.vue?vue&type=script&lang=js&"
export * from "./smsexample.vue?vue&type=script&lang=js&"
import style0 from "./smsexample.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports